/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { PropsWithChildren } from "react";
import { CSSObject } from "styled-components";
import { getMessage } from "./helpers";
import { NoData } from "./NoData";

type Props = PropsWithChildren<{
  hasData: boolean;
  messageComponent?: string | JSX.Element;
  renderNoData?: (message: JSX.Element) => JSX.Element;
  customCss?: CSSObject;
}>;

export function DataDisplayWrapper({
  children,
  hasData,
  messageComponent = "No Data Available",
  renderNoData = () => (
    <NoData
      customCss={{ justifyContent: "flex-start" }}
      message={getMessage(messageComponent)}
    />
  ),
  customCss,
}: Props) {
  if (hasData) {
    return <>{children}</>;
  }

  const message = getMessage(messageComponent);

  return <div css={customCss}>{renderNoData(message)}</div>;
}
